export const types = {
  SET_TRACK_METADATA: "SET_TRACK_METADATA",
  ADD_TRACK_METADATA_ITEM: "ADD_TRACK_METADATA_ITEM",
};

export const setTrackMetadata = payload => ({
  type: types.SET_TRACK_METADATA,
  payload,
});

export const addTrackMetadataItem = payload => ({
  type: types.ADD_TRACK_METADATA_ITEM,
  payload,
});
